import { forwardRef } from 'react'
import SignatureCanvas from 'react-signature-canvas'

import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'

const styles = {
  canvas: {
    width: '100%',
    height: '100%',
    border: '1px solid',
    borderColor: 'divider',
    borderRadius: 1,
    backgroundColor: (theme) => (theme.palette.mode === 'dark' ? 'grey.900' : undefined),
  },
}

/**
 * Display a sign pad
 *
 * @example of usage:
 *
 * ```jsx
 * const signPadRef = useRef()
 *
 * const handleSubmit = () => {
 *  // generate base64 string png image
 *  const png = signPadRef.current.getTrimmedCanvas().toDataURL('image/png')
 *  ...
 * }
 *
 * return <SignPad ref={signPadRef} />
 * ```
 */
const SignPad = forwardRef((props, ref) => {
  return (
    <Stack direction="row" spacing={1}>
      <Box sx={styles.canvas}>
        <SignatureCanvas ref={ref} canvasProps={{ width: 300, height: 100 }} />
      </Box>
      <Button variant="outlined" color="secondary" sx={{ alignSelf: 'flex-end' }} onClick={() => ref?.current.clear()}>
        Clear
      </Button>
    </Stack>
  )
})

export default SignPad
